import React from "react";
import ME from "../../assets/zakzouki.png";
import { FiAward } from "react-icons/fi";
import { BsBook } from "react-icons/bs";
import { AiOutlineTool } from "react-icons/ai";
import "./About.css";

const about = () => {
  return (
    <section id="about">
      <h5>Je me presente</h5>
      <h2>Qui suis-je</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FiAward className="about__icon" />
              <h4>Experience</h4>
              <small>3+ années d'experience </small>
            </article>
            <article className="about__card">
              <BsBook className="about__icon" />
              <h4> projets</h4>
              <small>10+ Projets (Web, Mobile, Desktop) </small>
            </article>
            <article className="about__card">
              <AiOutlineTool className="about__icon" />
              <h4> Téchnologies</h4>
              <small>18 langages, FrameWorks, outils </small>
            </article>
          </div>
          <p>
          Je suis Chajae Zakaria, un ingénieur Full Stack passionné par le développement logiciel sous tous ses aspects. Aujourd'hui, je suis ravi de partager avec vous mon parcours, mes compétences et ma passion pour la création d'applications web robustes et innovantes. Permets-moi de vous donner un aperçu de mon expérience en tant qu'ingénieur Full Stack.{" "}
          </p>
          <a href="#contact" className="btn btn-primary">
            {" "}
            Contacter moi
          </a>
        </div>
      </div>
      
    </section>
  );
};

export default about;
